export default __webpack_public_path__ + "static/media/double-rope-border-none.a038552c.svg";